import { create } from "zustand";

export type BudgetViewTab = "month" | "plan" | "wishlist";

/** This month, as its first day (``2026-11-01``): the month the wishlist is weighed against. */
const today = new Date();
export const THIS_MONTH = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;

/**
 * Which of its tabs the Budget view shows - the month until another is picked
 * in its strip; the wishlist is always this month's - and the month, as the first day of it (``2026-11-01``): this
 * month until another is picked. The subnav and the view both read them, and a
 * line's panel reads the month too, so the panel opened from a card shows that
 * card's month.
 */
type BudgetViewStore = {
  tab: BudgetViewTab;
  setTab: (tab: BudgetViewTab) => void;
  month: string;
  setMonth: (month: string) => void;
};

export const useBudgetViewStore = create<BudgetViewStore>((set) => ({
  tab: "month",
  setTab: (tab) => set({ tab }),
  month: THIS_MONTH,
  setMonth: (month) => set({ month }),
}));
